import React from "react";
import AppLayout from "./AppLayout";
import App from "../App";

export const CallbackPage = () => {
  return (
    <div className="page-layout">
      <AppLayout />
      <div className="page-layout__content" />
    </div>
  );
};